import Quill from 'quill';
import { PRIVATE_CLASS_NAME } from '../constants/richTextEditor';

const BlockEmbed = Quill.import('blots/block/embed');

// https://github.com/quilljs/quill/issues/1896#issuecomment-557792404
class PrivateClass extends BlockEmbed {
    static create(node) {
        return node;
    }
    static value(node) {
        return node;
    }
}

PrivateClass.blotName = 'privateClass';
PrivateClass.className = PRIVATE_CLASS_NAME;
PrivateClass.tagName = 'div';

export default PrivateClass;
